

const SVG_Thumb = `<svg width="24px" height="24px" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.29398 20.4966C4.56534 20.4966 4 19.8827 4 19.1539V12.3847C4 11.6559 4.56534 11.042 5.29398 11.042H8.12364L10.8534 4.92738C10.9558 4.69809 11.1677 4.54023 11.4114 4.50434L11.5175 4.49658C12.3273 4.49658 13.0978 4.85402 13.6571 5.48039C14.2015 6.09009 14.5034 6.90649 14.5034 7.7535L14.5027 8.92295L18.1434 8.92346C18.6445 8.92346 19.1173 9.13931 19.4618 9.51188L19.5612 9.62829C19.8955 10.0523 20.0479 10.6054 19.9868 11.1531L19.1398 18.742C19.0297 19.7286 18.2529 20.4966 17.2964 20.4966H8.69422H5.29398ZM11.9545 6.02658L9.41727 11.7111L9.42149 11.7693L9.42091 19.042H17.2964C17.4587 19.042 17.6222 18.8982 17.6784 18.6701L17.6942 18.5807L18.5412 10.9918C18.5604 10.8194 18.5134 10.6486 18.4189 10.5287C18.3398 10.4284 18.2401 10.378 18.1434 10.378H13.7761C13.3745 10.378 13.0488 10.0524 13.0488 9.65073V7.7535C13.0488 7.2587 12.8749 6.78825 12.5721 6.44915C12.4281 6.28794 12.2615 6.16343 12.0824 6.07923L11.9545 6.02658ZM7.96636 12.4966H5.45455V19.042H7.96636V12.4966Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M5.29398 20.4966C4.56534 20.4966 4 19.8827 4 19.1539V12.3847C4 11.6559 4.56534 11.042 5.29398 11.042H8.12364L10.8534 4.92738C10.9558 4.69809 11.1677 4.54023 11.4114 4.50434L11.5175 4.49658C12.3273 4.49658 13.0978 4.85402 13.6571 5.48039C14.2015 6.09009 14.5034 6.90649 14.5034 7.7535L14.5027 8.92295L18.1434 8.92346C18.6445 8.92346 19.1173 9.13931 19.4618 9.51188L19.5612 9.62829C19.8955 10.0523 20.0479 10.6054 19.9868 11.1531L19.1398 18.742C19.0297 19.7286 18.2529 20.4966 17.2964 20.4966H8.69422H5.29398ZM11.9545 6.02658L9.41727 11.7111L9.42149 11.7693L9.42091 19.042H17.2964C17.4587 19.042 17.6222 18.8982 17.6784 18.6701L17.6942 18.5807L18.5412 10.9918C18.5604 10.8194 18.5134 10.6486 18.4189 10.5287C18.3398 10.4284 18.2401 10.378 18.1434 10.378H13.7761C13.3745 10.378 13.0488 10.0524 13.0488 9.65073V7.7535C13.0488 7.2587 12.8749 6.78825 12.5721 6.44915C12.4281 6.28794 12.2615 6.16343 12.0824 6.07923L11.9545 6.02658ZM7.96636 12.4966H5.45455V19.042H7.96636V12.4966Z" fill="currentColor"></path></svg>`

export const FormExtension = {
  name: 'Forms',
  type: 'response',
  match: ({ trace }) =>
    trace.type === 'ext_form' || trace.payload.name === 'ext_form',
  render: ({ trace, element }) => {
    const formContainer = document.createElement('form')

    formContainer.innerHTML = `
      <style>
        label {
          font-size: 0.8em;
          color: #888;
        }
        input[type="text"], input[type="email"], input[type="tel"] {
          width: 100%;
          border: none;
          border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
          background: transparent;
          margin: 5px 0;
          outline: none;
        }
        .phone {
          width: 150px;
        }
        .invalid {
          border-color: red;
        }
        .submit {
          background: linear-gradient(to right, #2e6ee1, #2e7ff1 );
          border: none;
          color: white;
          padding: 10px;
          border-radius: 5px;
          width: 100%;
          cursor: pointer;
        }
      </style>

      <label for="name">Name</label>
      <input type="text" class="name" name="name" required><br><br>

      <label for="email">Email</label>
      <input type="email" class="email" name="email" required pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" title="Invalid email address"><br><br>

      <label for="phone">Phone Number</label>
      <input type="tel" class="phone" name="phone" required pattern="\\d+" title="Invalid phone number, please enter only numbers"><br><br>

      <input type="submit" class="submit" value="Submit">
    `

    formContainer.addEventListener('submit', function (event) {
      event.preventDefault()

      const name = formContainer.querySelector('.name')
      const email = formContainer.querySelector('.email')
      const phone = formContainer.querySelector('.phone')

      if (
        !name.checkValidity() ||
        !email.checkValidity() ||
        !phone.checkValidity()
      ) {
        name.classList.add('invalid')
        email.classList.add('invalid')
        phone.classList.add('invalid')
        return
      }

      formContainer.querySelector('.submit').remove()

      window.voiceflow.chat.interact({
        type: 'complete',
        payload: { name: name.value, email: email.value, phone: phone.value },
      })
    })

    element.appendChild(formContainer)
  },
}

export const MapExtension = {

  name: 'Maps',
  type: 'response',
  match: ({ trace }) =>
    trace.type === 'ext_map' || trace.payload.name === 'ext_map',
  render: ({ trace, element }) => {
    console.log("STEAP************* 2")
    const GoogleMap = document.createElement('iframe')
    const { apiKey, origin, destination, zoom, height, width } = trace.payload

    GoogleMap.width = width || '240'
    GoogleMap.height = height || '240'
    GoogleMap.style.border = '0'
    GoogleMap.loading = 'lazy'
    GoogleMap.allowFullscreen = true
    GoogleMap.src = `https://www.google.com/maps/embed/v1/directions?key=${apiKey}&origin=${origin}&destination=${destination}&zoom=${zoom}`

    element.appendChild(GoogleMap)
  },
}

export const VideoExtension = {
  name: 'Video',
  type: 'response',
  match: ({ trace }) =>
    trace.type === 'ext_video' || trace.payload.name === 'ext_video',
  render: ({ trace, element }) => {
    console.log("STEAP************* 3")
    const videoElement = document.createElement('video')
    const { videoURL, autoplay, controls } = trace.payload

    videoElement.width = 240
    videoElement.src = videoURL

    if (autoplay) {
      videoElement.setAttribute('autoplay', '')
    }
    if (controls) {
      videoElement.setAttribute('controls', '')
    }

    videoElement.addEventListener('ended', function () {
      window.voiceflow.chat.interact({ type: 'complete' })
    })
    element.appendChild(videoElement)
  },
}

export const TimerExtension = {
  name: 'Timer',
  type: 'response',
  match: ({ trace }) =>
    
    trace.type === 'ext_timer' || trace.payload.name === 'ext_timer',
  render: ({ trace, element }) => {
    console.log("STEAP************* 4")
    const { duration } = trace.payload || 5
    let timeLeft = duration

    const timerContainer = document.createElement('div')
    timerContainer.innerHTML = `<p>Time left: <span id="time">${timeLeft}</span></p>`

    const countdown = setInterval(() => {
      if (timeLeft <= 0) {
        clearInterval(countdown)
        window.voiceflow.chat.interact({ type: 'complete' })
      } else {
        timeLeft -= 1
        timerContainer.querySelector('#time').textContent = timeLeft
      }
    }, 1000)

    element.appendChild(timerContainer)
  },
}


export const FileUploadExtension = {

  
  name: 'FileUpload',
  type: 'response',
  match: ({ trace }) =>
    trace.type === 'ext_fileUpload' || trace.payload.name === 'ext_fileUpload',
   render: ({ trace, element }) => {
   const fileUploadContainer = document.createElement('div')
    fileUploadContainer.innerHTML = `
      <style>
        .my-file-upload {
          border: 2px dashed rgba(46, 110, 225, 0.3);
          padding: 20px;
          text-align: center;
          cursor: pointer;
         
        }
      
       
        
      </style>
      <div class='my-file-upload'>Drag and drop a file here or click to upload</div>
      <input type='file' style='display: none;'>
    `

    const fileInput = fileUploadContainer.querySelector('input[type=file]')
    const fileUploadBox = fileUploadContainer.querySelector('.my-file-upload')

    fileUploadBox.addEventListener('click', function () {
      fileInput.click()
    })

    fileInput.addEventListener('change', function () {
      const file = fileInput.files[0]
      console.log('File selected:', file)

     fileUploadContainer.innerHTML = `<img src="https://s3.amazonaws.com/com.voiceflow.studio/share/upload/upload.gif" alt="Upload" width="50" height="50">`

      var data = new FormData()
     data.append('data', file)

       fetch('https://exstentions-752ef99cf8f5.herokuapp.com/upl', {
        method: 'POST',
        body: data,
      })
        .then((response) => {
         // fileUploadContainer.innerHTML = '<div>so qua</div>'
         
          if (response.ok) {
           
           return response.json()
          } else {
            
            throw new Error('Upload failed: ' + response.statusText)
          }
        })
        .then((result) => {
        

           fileUploadContainer.innerHTML ='<img src="https://s3.amazonaws.com/com.voiceflow.studio/share/check/check.gif" alt="Done" width="50" height="50">'
       
          window.voiceflow.chat.interact({
            type: 'complete',
            payload: {
            file: result.Key.replace(), 
            },
       
          })
         
        //   fileUploadContainer.innerHTML =`<style>
          
   
        //   .c-PJLV-bKejPu-isRounded-true {
        //     border-radius: var(--radii-1);
        //     display: none;
        //     background-image: url('https://app.wosnic.com/public/wosnic.svg');
        //     background-size: cover; /* Adatta l'immagine per coprire l'intera area */
        //     background-position: center; /* Centra l'immagine */
        // }
        //   </style>
        //   `
        
          
        })
        .catch((error) => {
          console.error(error)
          fileUploadContainer.innerHTML = '<div>Error during upload</div>'
        })
    })
 
  
   element.appendChild(fileUploadContainer)
  },
}

export const KBUploadExtension = {
  name: 'KBUpload',
  type: 'response',
  match: ({ trace }) =>
    trace.type === 'ext_KBUpload' || trace.payload.name === 'ext_KBUpload',
  render: ({ trace, element }) => {
    console.log("STEAP************* 6")
    const apiKey = trace.payload.apiKey || null
    const maxChunkSize = trace.payload.maxChunkSize || 1000
    const tags = `tags=${JSON.stringify(trace.payload.tags)}&` || ''
    const overwrite = trace.payload.overwrite || false

    if (apiKey) {
      const kbfileUploadContainer = document.createElement('div')
      kbfileUploadContainer.innerHTML = `
      <style>
        .my-file-upload {
          border: 2px dashed rgba(46, 110, 225, 0.3);
          padding: 20px;
          text-align: center;
          cursor: pointer;
        }
      </style>
      <div class='my-file-upload'>Drag and drop a file here or click to upload</div>
      <input type='file' accept='.txt,.text,.pdf,.docx' style='display: none;'>
    `

      const fileInput = kbfileUploadContainer.querySelector('input[type=file]')
      const fileUploadBox =
        kbfileUploadContainer.querySelector('.my-file-upload')

      fileUploadBox.addEventListener('click', function () {
        fileInput.click()
      })

      fileInput.addEventListener('change', function () {
        const file = fileInput.files[0]

        kbfileUploadContainer.innerHTML = `<img src="https://s3.amazonaws.com/com.voiceflow.studio/share/upload/upload.gif" alt="Upload" width="50" height="50">`

        const formData = new FormData()
        formData.append('file', file)

        fetch(
          `https://api.voiceflow.com/v3alpha/knowledge-base/docs/upload?${tags}overwrite=${overwrite}&maxChunkSize=${maxChunkSize}`,
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              Authorization: apiKey,
            },
            body: formData,
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.json()
            } else {
              throw new Error('Upload failed: ' + response.statusText)
              window.voiceflow.chat.interact({
                type: 'error',
                payload: {
                  id: 0,
                },
              })
            }
          })
          .then((result) => {
            kbfileUploadContainer.innerHTML =
              '<img src="https://s3.amazonaws.com/com.voiceflow.studio/share/check/check.gif" alt="Done" width="50" height="50">'
            window.voiceflow.chat.interact({
              type: 'complete',
              payload: {
                id: result.data.documentID || 0,
              },
            })
          })
          .catch((error) => {
            console.error(error)
            kbfileUploadContainer.innerHTML = '<div>Error during upload</div>'
          })
      })
      element.appendChild(kbfileUploadContainer)
    }
  },
}

export const DateExtension = {
  name: 'Date',
  type: 'response',
  match: ({ trace }) =>
    trace.type === 'ext_date' || trace.payload.name === 'ext_date',
  render: ({ trace, element }) => {
    console.log("STEAP************* 7")
    const formContainer = document.createElement('form')

    // Get current date and time
    let currentDate = new Date()
    let minDate = new Date()
    minDate.setMonth(currentDate.getMonth() - 1)
    let maxDate = new Date()
    maxDate.setMonth(currentDate.getMonth() + 2)

    // Convert to ISO string and remove seconds and milliseconds
    let minDateString = minDate.toISOString().slice(0, 16)
    let maxDateString = maxDate.toISOString().slice(0, 16)

    formContainer.innerHTML = `
          <style>
            label {
              font-size: 0.8em;
              color: #888;
            }
            input[type="datetime-local"]::-webkit-calendar-picker-indicator {
                border: none;
                background: transparent;
                border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
                bottom: 0;
                outline: none;
                color: transparent;
                cursor: pointer;
                height: auto;
                left: 0;
                position: absolute;
                right: 0;
                top: 0;
                width: auto;
                padding:6px;
                font: normal 8px sans-serif;
            }
            .meeting input{
              background: transparent;
              border: none;
              padding: 2px;
              border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
              font: normal 14px sans-serif;
              outline:none;
              margin: 5px 0;
              &:focus{outline:none;}
            }
            .invalid {
              border-color: red;
            }
            .submit {
              background: linear-gradient(to right, #2e6ee1, #2e7ff1 );
              border: none;
              color: white;
              padding: 10px;
              border-radius: 5px;
              width: 100%;
              cursor: pointer;
              opacity: 0.3;
            }
            .submit:enabled {
              opacity: 1; /* Make the button fully opaque when it's enabled */
            }
          </style>
          <label for="date">Select your date/time</label><br>
          <div class="meeting"><input type="datetime-local" id="meeting" name="meeting" value="" min="${minDateString}" max="${maxDateString}" /></div><br>
          <input type="submit" id="submit" class="submit" value="Submit" disabled="disabled">
          `

    const submitButton = formContainer.querySelector('#submit')
    const datetimeInput = formContainer.querySelector('#meeting')

    datetimeInput.addEventListener('input', function () {
      if (this.value) {
        submitButton.disabled = false
      } else {
        submitButton.disabled = true
      }
    })
    formContainer.addEventListener('submit', function (event) {
      event.preventDefault()

      const datetime = datetimeInput.value
     // console.log(datetime)
      let [date, time] = datetime.split('T')

      formContainer.querySelector('.submit').remove()

      window.voiceflow.chat.interact({
        type: 'complete',
        payload: { date: date, time: time },
      })
    })
    element.appendChild(formContainer)
  },
}

export const ConfettiExtension = {
  name: 'Confetti',
  type: 'effect',
  match: ({ trace }) =>
    trace.type === 'ext_confetti' || trace.payload.name === 'ext_confetti',
  effect: ({ trace }) => {
    console.log("STEAP************* 7")
    const canvas = document.querySelector('#confetti-canvas')

    var myConfetti = confetti.create(canvas, {
      resize: true,
      useWorker: true,
    })
    myConfetti({
      particleCount: 200,
      spread: 160,
    })
  },
}

export const FeedbackExtension = {
  name: 'Feedback',
  type: 'response',
  match: ({ trace }) =>
    trace.type === 'ext_feedback' || trace.payload.name === 'ext_feedback',
  render: ({ trace, element }) => {
    console.log("STEAP************* 7")
    const feedbackContainer = document.createElement('div')

    feedbackContainer.innerHTML = `
          <style>
            .vfrc-feedback {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            .vfrc-feedback--description {
                font-size: 0.8em;
                color: grey;
                pointer-events: none;
            }

            .vfrc-feedback--buttons {
                display: flex;
            }

            .vfrc-feedback--button {
                margin: 0;
                padding: 0;
                margin-left: 0px;
                border: none;
                background: none;
                opacity: 0.2;
            }

            .vfrc-feedback--button:hover {
              opacity: 0.5; /* opacity on hover */
            }

            .vfrc-feedback--button.selected {
              opacity: 0.6;
            }

            .vfrc-feedback--button.disabled {
                pointer-events: none;
            }

            .vfrc-feedback--button:first-child svg {
                fill: none; /* color for thumb up */
                stroke: none;
                border: none;
                margin-left: 6px;
            }

            .vfrc-feedback--button:last-child svg {
                margin-left: 4px;
                fill: none; /* color for thumb down */
                stroke: none;
                border: none;
                transform: rotate(180deg);
            }
          </style>
          <div class="vfrc-feedback">
            <div class="vfrc-feedback--description">Was this helpful?</div>
            <div class="vfrc-feedback--buttons">
              <button class="vfrc-feedback--button" data-feedback="1">${SVG_Thumb}</button>
              <button class="vfrc-feedback--button" data-feedback="0">${SVG_Thumb}</button>
            </div>
          </div>
        `

    feedbackContainer
      .querySelectorAll('.vfrc-feedback--button')
      .forEach((button) => {
        button.addEventListener('click', function (event) {
          const feedback = this.getAttribute('data-feedback')
          window.voiceflow.chat.interact({
            type: 'complete',
            payload: { feedback: feedback },
          })

          feedbackContainer
            .querySelectorAll('.vfrc-feedback--button')
            .forEach((btn) => {
              btn.classList.add('disabled')
              if (btn === this) {
                btn.classList.add('selected')
              }
            })
        })
      })

    element.appendChild(feedbackContainer)
  },
}

export const NumberExtension = {
  name: "Number",
  type: "response",
  match: ({ trace }) =>
    trace.type === "ext_number" || trace.payload.name === "ext_number",
  render: ({ trace, element }) => {
   //console.log("NumberExtension render function called");
    const formContainer = document.createElement("form");

    // Estrai i testi dal payload
    const texts = trace.payload.texts || {};
    const submitText = texts.submitText;

    if (!submitText) {
      console.error(
        "Il testo del submit non è disponibile nel payload del trace.",
      );
      return;
    }

    const maxNumber = 5;

    const options = Array.from({ length: maxNumber }, (_, i) => {
      const value = i + 1;
      return `<option value="${value}">${value}</option>`;
    }).join("");

    formContainer.innerHTML = `
    <style>
      .form-container {
        display: flex;
        flex-direction: column;
        align-items: left;
        width: 100%;
        margin: auto;
        font-family: 'Segoe UI', sans-serif;
      }

      .number-selection {
        position: relative;
      }

      .number-selection select {
        height: 40px;
        background-color: #f7f7f7;
        border: 1px solid #d1d1d1;
        border-radius: 8px;
        padding: 10px;
        font-size: 16px;
        font-family: 'Segoe UI', sans-serif;
        outline: none;
        box-sizing: border-box;
        cursor: pointer;
        appearance: none;
      }

      .number-selection select:focus {
        border-color: #2e7ff1;
        box-shadow: 0 0 0 2px rgba(46, 127, 241, 0.2);
      }

      .submit {
        background: linear-gradient(to right, #2e6ee1, #2e7ff1);
        border: none;
        color: white;
        padding: 10px;
        border-radius: 5px;
        width: 100%;
        cursor: pointer;
        opacity: 0.3;
        transition: opacity 0.3s ease, box-shadow 0.3s ease;
        font-size: 16px;
        font-family: 'Segoe UI', sans-serif;
        margin-top: 5px;
      }

      .submit:enabled {
        opacity: 1;
      }

      .submit:hover:enabled {
        box-shadow: 0 4px 8px rgba(46, 110, 225, 0.2);
      }

      .submit:disabled {
        cursor: not-allowed;
      }
    </style>
    <div class="form-container">
      <div class="number-selection">
        <select id="number-select" name="number-select">
          <option value="" disabled selected>--</option>
          ${options}
        </select>
      </div>
      <input 
        type="submit" 
        id="submit" 
        class="submit" 
        value="${submitText}" 
        disabled 
      />
    </div>
    `;

    const submitButton = formContainer.querySelector("#submit");
    const numberSelect = formContainer.querySelector("#number-select");

    // Imposta inizialmente il pulsante come non visibile

    // Aggiungi l'elemento al DOM
    element.appendChild(formContainer);

    const chatInputContainer = document
      .querySelector("#voiceflow-chat")
      .shadowRoot.querySelector("footer > div");
    if (chatInputContainer) {
      chatInputContainer.style.display = "none";
    }

    // Mostra il pulsante di submit solo dopo che un numero è stato selezionato
    numberSelect.addEventListener("change", function () {
      const selectedValue = this.value;

      if (selectedValue) {
        submitButton.style.display = "block"; // Rendi visibile il pulsante
        submitButton.disabled = false; // Abilita il pulsante
      } else {
        submitButton.style.visibility = "hidden"; // Nascondi il pulsante
        submitButton.disabled = true; // Disabilita il pulsante
      }
    });

    // Listener per la sottomissione del form
    formContainer.addEventListener("submit", function (event) {
      event.preventDefault();
      const selectedNumber = numberSelect.value;

      if (selectedNumber) {
       // console.log("Numero selezionato:", selectedNumber);

        if (chatInputContainer) {
          chatInputContainer.style.display = "";
        }

        numberSelect.disabled = true;
        submitButton.disabled = true;
        submitButton.style.display = "none";

        window.voiceflow.chat.interact({
          type: "data",
          payload: { number: selectedNumber },
        });
      }
    });
  },
};

export const ChildrenAgesExtension = {
  name: "ChildrenAges",
  type: "response",
  match: ({ trace }) =>
    trace.type === "ext_children_ages" ||
    trace.payload.name === "ext_children_ages",
  render: ({ trace, element }) => {
   // console.log("ChildrenAgesExtension render function called");
    const formContainer = document.createElement("form");

    // Estrai i testi dal payload
    const texts = trace.payload.texts || {};

    const enterAge = texts.enterAge;
    const submitText = texts.submitText;
    const chooseNumberText = texts.chooseNumberText;

    // Verifica che tutti i testi necessari siano disponibili
    if (!enterAge || !submitText || !chooseNumberText) {
      console.error(
        "Uno o più testi non sono disponibili nel payload del trace.",
      );
      return; // Interrompi l'esecuzione se i testi non sono disponibili
    }

    // Definisci il numero massimo di bambini consentiti
    const maxChildren = 4;

    // Genera le opzioni da 0 a maxChildren per il numero di bambini
    const options = Array.from({ length: maxChildren + 1 }, (_, i) => {
      return `<option value="${i}">${i}</option>`;
    }).join("");

    // Crea l'HTML per l'input iniziale e i campi dinamici
    formContainer.innerHTML = `
      <style>
      .form-container1 {
        display: flex;
        flex-direction: column;
        align-items: left;
        width: 100%;
        margin: auto;
        font-family: 'Segoe UI', sans-serif;
      }

      .input-group {
        margin: 10px 0;
        display: flex;
        flex-direction: column;
      }

      .input-group select {
        padding: 10px;
        font-size: 16px;
        border: 1px solid #d1d1d1;
        border-radius: 8px;
        outline: none;
        box-sizing: border-box;
	    appearance: none; /* Nasconde l'aspetto nativo del selettore */

      }

      .input-group select:focus {
        border-color: #2e7ff1;
        box-shadow: 0 0 0 2px rgba(46, 127, 241, 0.2);
      }

      .additional-inputs {
      }

      .age-input-container {
        display: flex;
        align-items: left;
        margin-bottom: 10px;
      }

      .age-input {
        flex: 1;
        padding: 10px;
        font-size: 16px;
        border: 1px solid #d1d1d1;
        border-radius: 8px;
        outline: none;
        box-sizing: border-box;
      }

      .age-input:focus {
        border-color: #2e7ff1;
        box-shadow: 0 0 0 2px rgba(46, 127, 241, 0.2);
      }

      .submit {
        background: linear-gradient(to right, #2e6ee1, #2e7ff1);
        border: none;
        color: white;
        padding: 12px;
        border-radius: 5px;
        width: 100%;
        cursor: pointer;
        opacity: 0.3;
        transition: opacity 0.3s ease, box-shadow 0.3s ease;
        font-size: 16px;
        
        display: block;
      }

      .submit:enabled {
        opacity: 1;
      }

      .submit:hover:enabled {
        box-shadow: 0 4px 8px rgba(46, 110, 225, 0.2);
      }

      .submit:disabled {
        cursor: not-allowed;
      }
    </style>
      <div class="form-container1">
        <div class="input-group">
          <select id="number-select" name="number-select">
            <option value="" disabled selected>--</option>
            ${options}
          </select>
        </div>
        <div class="additional-inputs" id="additional-inputs"></div>
        <input 
          type="submit" 
          id="submit" 
          class="submit" 
          value="${submitText}"
          disabled 
        />
      </div>
    `;

    const submitButton = formContainer.querySelector("#submit");
    const numberSelect = formContainer.querySelector("#number-select");
    const additionalInputsContainer =
      formContainer.querySelector("#additional-inputs");

    // Aggiungi l'elemento al DOM
    element.appendChild(formContainer);

    // Nascondi l'input della chat
    const chatInputContainer = document
      .querySelector("#voiceflow-chat")
      .shadowRoot.querySelector("footer > div");
    if (chatInputContainer) {
      chatInputContainer.style.display = "none";
    }

    // Listener per la selezione del numero di bambini
    numberSelect.addEventListener("change", function () {
      // Pulisce eventuali input aggiuntivi esistenti
      additionalInputsContainer.innerHTML = "";

      const selectedNumber = parseInt(this.value, 10);

      // Genera gli input aggiuntivi per le età dei bambini solo se selezionato > 0
      if (selectedNumber > 0) {
        for (let i = 0; i < selectedNumber; i++) {
          const inputWrapper = document.createElement("div");
          inputWrapper.className = "age-input-container";

          const inputField = document.createElement("input");
          inputField.type = "number";
          inputField.min = "0";
          inputField.max = "12";
          inputField.placeholder = enterAge;
          inputField.required = true;
          inputField.className = "age-input";

          inputWrapper.appendChild(inputField);
          additionalInputsContainer.appendChild(inputWrapper);
        }

        // Disabilita il pulsante di submit finché tutti i campi non sono compilati
        submitButton.disabled = true;

        // Aggiungi listener per abilitare il pulsante di submit quando tutti gli input sono compilati
        const inputFields = additionalInputsContainer.querySelectorAll(
          'input[type="number"]',
        );
        inputFields.forEach((input) => {
          input.addEventListener("input", checkAllInputsFilled);
        });
      } else {
        // Se il numero selezionato è 0, abilita direttamente il pulsante di submit
        submitButton.disabled = false;
      }

      // Mostra il pulsante di submit
      submitButton.style.display = "block";
    });

    // Funzione per controllare se tutti gli input sono compilati correttamente
    const checkAllInputsFilled = () => {
      const inputFields = additionalInputsContainer.querySelectorAll(
        'input[type="number"]',
      );
      const allFilled = Array.from(inputFields).every((field) => {
        const value = field.value;
        return value !== "" && value >= 0 && value <= 12;
      });
      submitButton.disabled = !allFilled;
    };

    // Listener per la sottomissione del form
    formContainer.addEventListener("submit", function (event) {
      event.preventDefault();

      const selectedNumber = parseInt(numberSelect.value, 10);

      // Colleziona le età inserite
      const inputValues = [];
      if (selectedNumber > 0) {
        const inputFields = additionalInputsContainer.querySelectorAll(
          'input[type="number"]',
        );
        inputFields.forEach((input) => {
          inputValues.push(parseInt(input.value, 10));
        });
      }

     // console.log("Età inserite:", inputValues);

      // Riabilita l'input della chat
      if (chatInputContainer) {
        chatInputContainer.style.display = "";
      }

      // Disabilita il form
      numberSelect.disabled = true;
      const ageInputs = additionalInputsContainer.querySelectorAll(
        'input[type="number"]',
      );
      ageInputs.forEach((input) => {
        input.disabled = true;
      });
      submitButton.disabled = true;
      submitButton.style.opacity = "0.3";
      submitButton.style.cursor = "not-allowed";
      submitButton.style.display = "none";
      // Invia i dati selezionati a Voiceflow
      window.voiceflow.chat.interact({
        type: "data",
        payload: {
          numberOfChildren: selectedNumber,
          ages: inputValues,
        },
      });
    });
  },
};

export const ButtonExtension = {
  name: "DynamicButtons",
  type: "response",
  match: ({ trace }) =>
    trace.type === "ext_buttons" || trace.payload.name === "ext_buttons",
  render: ({ trace, element }) => {
   // console.log("Rendering Dynamic Buttons");

    const buttonContainer = document.createElement("div");
    buttonContainer.style.display = "flex";
    buttonContainer.style.flexDirection = "row";
    buttonContainer.style.justifyContent = "center";
    buttonContainer.style.gap = "10px";

    // Dati del lead
    const lead = trace.payload.lead;
    if (!lead || !lead.name || !lead.email || !lead.cell) {
      console.error("Dati del lead mancanti o incompleti:", lead);
      return;
    }

    const buttons = trace.payload.buttons;
    if (!buttons || !Array.isArray(buttons) || buttons.length < 2) {
      console.error("Il payload deve contenere almeno due pulsanti.");
      return;
    }

    buttons.forEach((button, index) => {
      const btn = document.createElement("button");
      btn.textContent = button.label;
      btn.id = `button-${index}`;
      btn.style.padding = "10px 20px";
      btn.style.backgroundColor = "#3B6BA4";
      btn.style.color = "#fff";
      btn.style.border = "none";
      btn.style.borderRadius = "5px";
      btn.style.cursor = "pointer";
      btn.style.fontSize = "16px";

      btn.addEventListener("click", () => {
       // console.log(`Pulsante cliccato: ${button.label}`);

        // Nascondi tutti i pulsanti tranne quello cliccato
        Array.from(buttonContainer.children).forEach((child) => {
          if (child !== btn) {
            child.style.display = "none";
          }
        });

        // Cambia lo stile del pulsante cliccato (opzionale)
        btn.style.cursor = "not-allowed";

        // Disabilita il pulsante
        btn.disabled = true;

        // Invia evento Pixel con i dati del pulsante e del lead
        if (window.fbq) {
          window.fbq("trackCustom", "ButtonClicked", {
            buttonId: btn.id,
            label: button.label,
            data: button.data,
            lead: {
              name: lead.name,
              email: lead.email,
              cell: lead.cell,
            },
          });
        //  console.log("Evento Pixel inviato con successo.");
        } else {
          console.warn("Pixel non disponibile");
        }

        // Invia l'evento con i dati del pulsante e del lead a Voiceflow
        window.voiceflow.chat.interact({
          type: "data",
          payload: {
            button: button.data,
            lead: {
              name: lead.name,
              email: lead.email,
              cell: lead.cell,
            },
          },
        });
       // console.log("Evento Voiceflow inviato con successo.");

        // **Rendi visibile nuovamente l'input della chat**
        const chatInputContainer = document
          .querySelector("#voiceflow-chat")
          .shadowRoot.querySelector("footer > div");
        if (chatInputContainer) {
          chatInputContainer.style.display = ""; // Rendi nuovamente visibile
        //  console.log("Input della chat ripristinato.");
        }
      });

      buttonContainer.appendChild(btn);
    });

    // Aggiungi i pulsanti al DOM
    element.appendChild(buttonContainer);

    // Nascondi l'input della chat
    const chatInputContainer = document
      .querySelector("#voiceflow-chat")
      .shadowRoot.querySelector("footer > div");
    if (chatInputContainer) {
      chatInputContainer.style.display = "none";
    }
  },
};

export const DateExtensionVnl = {
  name: "Date3",
  type: "response",
  match: ({ trace }) =>
    trace.type === "ext_datevnl" || trace.payload.name === "ext_datevnl",
  render: ({ trace, element }) => {
    console.log("STEP************* 7");
    const formContainer = document.createElement("form");

    // Estrai i testi e il formato dal payload
    const texts = trace.payload.texts || {};
    const submitText = texts.submitText;
    const displayDateFormat = trace.payload.displayDateFormat || "DD/MM/YYYY";

    // Verifica che il testo del submit sia disponibile
    if (!submitText) {
      console.error(
        "Il testo del submit non è disponibile nel payload del trace.",
      );
      return;
    }

    // Estrai minDate e maxDate dal payload
    // let minDateString = trace.payload.minDate;
    // let maxDateString = trace.payload.maxDate;

    // Se minDate o maxDate non sono fornite, imposta valori predefiniti
    // if (!minDateString || !maxDateString) {
    //   let currentDate = new Date();
    //   let minDate = new Date();
    //   minDate.setMonth(currentDate.getMonth());
    //   let maxDate = new Date();
    //   maxDate.setMonth(currentDate.getMonth() + 12);

    //   minDateString = minDate.toISOString().split("T")[0];
    //   maxDateString = maxDate.toISOString().split("T")[0];
    // }

// Estrai minDate e maxDate dal payload
let minDateString = trace.payload.minDate;
let maxDateString = trace.payload.maxDate;

// Data odierna
let currentDate = new Date();
let currentDateString = currentDate.toISOString().split("T")[0];

// Controlla minDate e maxDate
if (minDateString) {
  // Se la data minima è antecedente alla data odierna, usa la data odierna
  if (new Date(minDateString) < currentDate) {
    minDateString = currentDateString;
  }
} else {
  // Se minDate non è fornita, usa la data odierna
  minDateString = currentDateString;
}

// Se maxDate non è fornita, imposta un valore predefinito
if (!maxDateString) {
  let maxDate = new Date();
  maxDate.setMonth(currentDate.getMonth() + 12);
  maxDateString = maxDate.toISOString().split("T")[0];
}



    formContainer.innerHTML = `
    <style>
      /* Il tuo CSS rimane invariato */
      .form-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        font-family: 'Segoe UI', sans-serif;
      }

      .meeting {
        position: relative;
        width: 100%;
        margin: 6px 0;
        align-items: left;
      }

      .meeting input[type="date"] {
        width: 100%;
        background-color: #f7f7f7;
        border: 1px solid #d1d1d1;
        border-radius: 8px;
        padding: 10px;
        font-size: 16px;
        font-family: 'Segoe UI', sans-serif;
        line-height: 1.5;
        outline: none;
        box-sizing: border-box;
        cursor: pointer;
        margin: 0px 1px;
      }

      .meeting input[type="date"]:focus {
        border-color: #2e7ff1;
        box-shadow: 0 0 0 2px rgba(46, 127, 241, 0.2);
      }

      .meeting .selected-date {
        font-size: 16px;
        font-family: 'Segoe UI', sans-serif;
        line-height: 1.5;
        padding: 10px;
        border: 1px solid #d1d1d1;
        border-radius: 8px;
        background-color: #f7f7f7;
        width: 100%;
        text-align: center;
      }

      .submit {
        background: linear-gradient(to right, #2e6ee1, #2e7ff1);
        border: none;
        color: white;
        padding: 10px;
        border-radius: 5px;
        width: 100%;
        cursor: pointer;
        opacity: 0.3;
        transition: opacity 0.3s ease, box-shadow 0.3s ease;
        font-size: 16px;
        font-family: 'Segoe UI', sans-serif;
        margin: 0 auto;
      }

      .submit:enabled {
        opacity: 1;
      }

      .submit:hover:enabled {
        box-shadow: 0 4px 8px rgba(46, 110, 225, 0.2);
      }

      .submit:disabled {
        cursor: not-allowed;
      }
    </style>
    <div class="form-container">
      <div class="meeting">
        <input 
          type="date" 
          id="meeting" 
          name="meeting" 
          min="${minDateString}" 
          max="${maxDateString}" 
        />
      </div>
      <input 
        type="submit" 
        id="submit" 
        class="submit" 
        value="${submitText}"
        disabled 
      />
    </div>
    `;

    const submitButton = formContainer.querySelector("#submit");
    const dateInput = formContainer.querySelector("#meeting");

    // Abilita il pulsante di submit quando viene selezionata una data
    dateInput.addEventListener("input", function () {
      submitButton.disabled = !this.value;
    });

    // Aggiungi l'elemento al DOM
    element.appendChild(formContainer);

    // Nascondi l'input della chat
    const chatInputContainer = document
      .querySelector("#voiceflow-chat")
      .shadowRoot.querySelector("footer > div");
    if (chatInputContainer) {
      chatInputContainer.style.display = "none";
    }

    formContainer.addEventListener("submit", function (event) {
      event.preventDefault();
      const selectedDate = dateInput.value;

      // Verifica se la data è valida prima di inviare
      if (selectedDate) {
       // console.log("Data selezionata:", selectedDate);

        // Riabilita l'input della chat
        if (chatInputContainer) {
          chatInputContainer.style.display = "";
        }

        // Nascondi l'input di tipo "date" e mostra la data selezionata
        dateInput.style.display = "none";
        const selectedDateDisplay = document.createElement("span");
        selectedDateDisplay.className = "selected-date";

        // **Formattazione della data**
        const dateObj = new Date(selectedDate);

        // Funzione per formattare la data in base al formato specificato
        function formatDate(dateObj, format) {
          const day = String(dateObj.getDate()).padStart(2, "0");
          const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // I mesi vanno da 0 a 11
          const year = dateObj.getFullYear();
          const mesi = [
            "gennaio",
            "febbraio",
            "marzo",
            "aprile",
            "maggio",
            "giugno",
            "luglio",
            "agosto",
            "settembre",
            "ottobre",
            "novembre",
            "dicembre",
          ];
          const giorniSettimana = [
            "Domenica",
            "Lunedì",
            "Martedì",
            "Mercoledì",
            "Giovedì",
            "Venerdì",
            "Sabato",
          ];

          const monthName = mesi[dateObj.getMonth()];
          const dayOfWeek = giorniSettimana[dateObj.getDay()];

          let formattedDate = format
            .replace("DD", day)
            .replace("MM", month)
            .replace("YYYY", year)
            .replace("Month", monthName)
            .replace("Day", dayOfWeek);

          return formattedDate;
        }

        // Formatta la data utilizzando la funzione
        const formattedDate = formatDate(dateObj, displayDateFormat);

        // Imposta il testo dell'elemento con la data formattata
        selectedDateDisplay.textContent = formattedDate;

        dateInput.parentNode.appendChild(selectedDateDisplay);

        // Nascondi il pulsante di invio
        submitButton.style.display = "none";

        // Invia la data selezionata a Voiceflow
        window.voiceflow.chat.interact({
          type: "data",
          payload: { date: selectedDate },
        });
      } else {
        console.warn("Nessuna data selezionata");
      }
    });
  },
};

export const DateExtension2Vnl = {
  name: "Date4",
  type: "response",
  match: ({ trace }) =>
    trace.type === "ext_date2vnl" || trace.payload.name === "ext_date2vnl",
  render: ({ trace, element }) => {
    console.log("STEP************* 7");
    const formContainer = document.createElement("form");

    let date_arrivo = trace.payload.date_arrivo;
    let submitText = trace.payload.submitText;
    let maxDatePayload = trace.payload.maxDate; // **Estrai maxDate dal payload**
    let displayDateFormat = trace.payload.displayDateFormat;

    if (!date_arrivo) {
      console.error(
        "La variabile date_arrivo non è disponibile nel payload del trace.",
      );
      return; // Interrompi l'esecuzione se date_arrivo non è disponibile
    }

    // Impostare minDate utilizzando date_arrivo
    let minDate = new Date(date_arrivo);

    // **Aggiungere un giorno a minDate**
    minDate.setDate(minDate.getDate() + 1);

    let maxDate;

    // **Utilizza maxDate dal payload se fornito**
    if (maxDatePayload) {
      maxDate = new Date(maxDatePayload);
    } else {
      // Se maxDate non è fornito, aggiungi 12 mesi a minDate
      maxDate = new Date(minDate);
      maxDate.setMonth(maxDate.getMonth() + 12);
    }

    let minDateString = minDate.toISOString().split("T")[0];
    let maxDateString = maxDate.toISOString().split("T")[0];

    formContainer.innerHTML = `
    <style>
      /* Il tuo CSS rimane invariato */
    </style>
    <div class="form-container">
      <div class="meeting">
        <input 
          type="date" 
          id="meeting" 
          name="meeting" 
          min="${minDateString}" 
          max="${maxDateString}" 
        />
      </div>
      <input 
        type="submit" 
        id="submit" 
        class="submit" 
        value="${submitText}"
        disabled 
      />
    </div>
    `;

    const submitButton = formContainer.querySelector("#submit");
    const dateInput = formContainer.querySelector("#meeting");

    // Abilita il pulsante di submit quando viene selezionata una data
    dateInput.addEventListener("input", function () {
      submitButton.disabled = !this.value;
    });

    // Aggiungi l'elemento al DOM
    element.appendChild(formContainer);

    // **Nascondi l'input della chat**
    const chatInputContainer = document
      .querySelector("#voiceflow-chat")
      .shadowRoot.querySelector("footer > div");
    if (chatInputContainer) {
      chatInputContainer.style.display = "none";
    }

    formContainer.addEventListener("submit", function (event) {
      event.preventDefault();
      const selectedDate = dateInput.value;

      // Verifica se la data è valida prima di inviare
      if (selectedDate) {
       // console.log("Data selezionata:", selectedDate);

        // **Riabilita l'input della chat**
        if (chatInputContainer) {
          chatInputContainer.style.display = "";
        }

        // Nascondi l'input di tipo "date" e mostra la data selezionata
        dateInput.style.display = "none";
        const selectedDateDisplay = document.createElement("span");
        selectedDateDisplay.className = "selected-date";

        // **Formattazione della data**
        const dateObj = new Date(selectedDate);

        // Funzione per formattare la data in base al formato specificato
        function formatDate(dateObj, format) {
          const day = String(dateObj.getDate()).padStart(2, "0");
          const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // I mesi vanno da 0 a 11
          const year = dateObj.getFullYear();
          const mesi = [
            "gennaio",
            "febbraio",
            "marzo",
            "aprile",
            "maggio",
            "giugno",
            "luglio",
            "agosto",
            "settembre",
            "ottobre",
            "novembre",
            "dicembre",
          ];
          const giorniSettimana = [
            "Domenica",
            "Lunedì",
            "Martedì",
            "Mercoledì",
            "Giovedì",
            "Venerdì",
            "Sabato",
          ];

          const monthName = mesi[dateObj.getMonth()];
          const dayOfWeek = giorniSettimana[dateObj.getDay()];

          let formattedDate = format
            .replace("DD", day)
            .replace("MM", month)
            .replace("YYYY", year)
            .replace("Month", monthName)
            .replace("Day", dayOfWeek);

          return formattedDate;
        }

        // Formatta la data utilizzando la funzione
        const formattedDate = formatDate(dateObj, displayDateFormat);

        // Imposta il testo dell'elemento con la data formattata
        selectedDateDisplay.textContent = formattedDate;

        dateInput.parentNode.appendChild(selectedDateDisplay);

        // **Nascondi il pulsante di invio**
        submitButton.style.display = "none";

        // Invia la data selezionata a Voiceflow
        window.voiceflow.chat.interact({
          type: "data",
          payload: { date: selectedDate },
        });
      } else {
        console.warn("Nessuna data selezionata");
      }
    });
  },
};